(function() {
    'use strict';

    angular.module('app').controller('SignInController', SignInController);

    SignInController.$inject = [
        '$scope',
        '$rootScope',
        '$http',
        '$state',
        '$localStorage',
        '$translate',
        '$stateParams',
        '$window',
    ];

    function SignInController($scope, $rootScope, $http, $state, $localStorage, $translate, $stateParams, $window) {
        $scope.user = {};
        $scope.auth = {
            error: null,
            message: '',
        };
        $scope.error = null;
        $scope.authMessage = '';

        if ($stateParams.email) {
            $scope.user.email = $stateParams.email;
            $scope.authMessage = $translate.instant('access.yourAccountIsReady');
        }

        function init() {
            $('[ng-model="user.email"]').focus();
        }

        if ($localStorage.isSignedIn) {
            $state.go('app.object');
        }

        $scope.login = function() {
            $scope.auth.error = null;

            if ($window.ga) {
                $window.ga('send', 'event', 'clientLogin', $scope.user.email);
            }

            $http
                .post('/rest-api/auth', {
                    email: $scope.user.email,
                    password: $scope.user.password,
                    keepLogged: $scope.user.keepLogged ? $scope.user.keepLogged : 0,
                })
                .then(
                    function() {
                        $rootScope.$broadcast('broadcastTollInstruction', true);

                        $('.SigninForm').addClass('fadeOutUp');
                        $state.go('app.object');
                    },
                    function(error) {
                        if (error.data.message === 'AccountIsBlocked') {
                            $scope.auth.error = $translate.instant('access.login.accountIsBlocked');
                        } else {
                            $scope.auth.error = $translate.instant('access.login.wrongpassword');
                        }
                    }
                );
        };

        $scope.openForgotPasswordModal = function() {
            var $isolated = $scope.$new(true);
            $isolated.user = {};

            $ngConfirm({
                title: $translate.instant('access.login.forgot.modal.header'),
                contentUrl: 'tpl/pages/signin/modals/forgot.html',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'fas',
                scope: $isolated,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.save.ok'),
                        btnClass: 'btn-success',
                        action: function(scope) {
                            return false;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };

        init();
    }
})();
